import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.expandable-filter-section-toggle .p-button {
  border: 1px solid ${dt('form.field.border.color')};
  background: ${dt('form.field.background')};
  color: ${dt('surface.700')};
  border-radius: ${dt('form.field.border.radius')};
}

.expandable-filter-section-toggle .p-button:hover {
  border-color: ${dt('form.field.hover.border.color')};
  background: ${dt('form.field.filled.hover.background')};
  color: ${dt('surface.700')};
}

.expandable-filter-section-toggle .p-button .p-button-icon {
  color: ${dt('surface.700')};
}

.expandable-filter-section-toggle .p-button {
  @media screen and (min-width: 768px) and (max-width: 1439px) {
    font-size: ${dt('form.field.sm.font.size')} !important;
    line-height: ${dt('form.field.sm.font.lineHeight')} !important;
    padding: ${dt('form.field.sm.padding.y')} ${dt('form.field.sm.padding.x')};
  }

  @media screen and (min-width: 1440px) and (max-width: 1919px) {
    font-size: ${dt('form.field.md.font.size')} !important;
    line-height: ${dt('form.field.md.font.lineHeight')} !important;
    padding: ${dt('form.field.md.padding.y')} ${dt('form.field.md.padding.x')};
  }

  @media screen and (min-width: 1920px) {
    font-size: ${dt('form.field.lg.font.size')} !important;
    line-height: ${dt('form.field.lg.font.lineHeight')} !important;
    padding: ${dt('form.field.lg.padding.y')} ${dt('form.field.lg.padding.x')};
  }
}
`;
